import { createSlug } from "./services";

const modalityEntries = [
  {
    title: "Luxury Spa Treatment",
    tagline:
      "A high-end spa ritual that wraps the body in comfort and the mind in stillness.",
    description:
      "Luxury Spa Treatment blends massage, spa service, and relaxation therapy into one premium wellness experience for guests who want to feel deeply restored.",
    about:
      "This modality is ideal for anyone looking for a premium spa service in Pune that feels immersive, calming, and beautifully paced. It combines the softness of relaxation therapy with the polished feel of a high-end massage experience, making it a strong choice for stress relief and full-body renewal.",
    benefits: [
      "Deep stress relief and a more peaceful state of mind",
      "Whole-body relaxation that helps reduce fatigue and heaviness",
      "Comfort-focused massage support that encourages better sleep",
      "A refined spa ritual for guests who want premium wellness care",
    ],
    whyChoose: [
      "A luxury spa format created for high comfort and elegant relaxation",
      "Professional therapists who understand pacing, pressure, and guest care",
      "Clean, hygienic service standards for a reassuring spa experience",
      "A polished treatment flow that feels calming from start to finish",
    ],
    experience: [
      "Consultation: Review your preferred pace, comfort level, and relaxation goals.",
      "Therapy: Settle into a premium spa treatment designed to ease tension and quiet the nervous system.",
      "Relaxation: Leave feeling lighter, calmer, and ready for deep rest.",
    ],
    image: "/assets/11-spa.jpg",
  },
  {
    title: "Deep Tissue Massage",
    tagline:
      "Targeted therapeutic pressure for guests who need powerful relief and a smoother recovery.",
    description:
      "Deep Tissue Massage focuses on deeper muscular tension while still delivering a premium spa experience that supports pain reduction, relaxation, and physical ease.",
    about:
      "This modality is well suited for guests searching for massage in Pune that goes beyond surface relaxation. It helps release tight areas in the back, shoulders, and legs while maintaining the calm, clean feel of a polished spa service.",
    benefits: [
      "Pain reduction support for tight, heavy, or overworked muscles",
      "Stress relief combined with stronger therapeutic bodywork",
      "Improved comfort after long workdays, travel, or physical strain",
      "A more relaxed body that can unwind more easily at night",
    ],
    whyChoose: [
      "A premium deep-pressure treatment delivered with care and control",
      "Professional therapists trained to work on persistent muscular tension",
      "Hygienic, comfort-led service with strong attention to guest experience",
      "A powerful option for guests who need real relief and relaxation together",
    ],
    experience: [
      "Consultation: Identify the areas that need the most attention and pressure support.",
      "Therapy: Receive focused deep tissue work that helps loosen built-up tension.",
      "Relaxation: Finish with a lighter, more mobile body and a calmer overall feel.",
    ],
    image: "/assets/1-spa.jpg",
  },
  {
    title: "Aromatherapy Massage",
    tagline:
      "A fragrant, soft-touch escape designed to calm the mind and soothe the body.",
    description:
      "Aromatherapy Massage combines essential oils with flowing massage therapy to create a spa service centered on emotional ease, full-body relaxation, and gentle wellness support.",
    about:
      "For guests who want massage in Pune with a more sensory, mood-softening experience, this modality is a beautiful fit. The blend of aroma and relaxation therapy helps reduce stress, encourage better sleep, and create a premium spa atmosphere.",
    benefits: [
      "Stress relief with a softer, more nurturing spa mood",
      "Relaxation therapy that supports calm breathing and easier sleep",
      "Gentle massage work that helps reduce body tension",
      "A premium aromatic spa service for emotional and physical comfort",
    ],
    whyChoose: [
      "A refined spa ritual for guests who value atmosphere and fragrance",
      "Professional therapists who balance gentle bodywork with calming flow",
      "A hygienic, polished treatment environment that feels restorative",
      "An ideal option for evening relaxation and luxury self-care",
    ],
    experience: [
      "Consultation: Choose your comfort level and preferred scent direction.",
      "Therapy: Enjoy a calming aromatherapy massage with smooth, relaxing strokes.",
      "Relaxation: Leave feeling grounded, softened, and mentally refreshed.",
    ],
    image: "/assets/3-spa.jpg",
  },
  {
    title: "Couples Massage",
    tagline:
      "A shared luxury massage experience designed for connection, comfort, and complete relaxation.",
    description:
      "Couples Massage creates a premium spa service for two, combining relaxation therapy, synchronized care, and a memorable high-end wellness atmosphere.",
    about:
      "This modality is perfect for guests who want to enjoy massage and spa relaxation together. It offers the calm of a professional treatment with the added warmth of a shared experience, making it ideal for celebrations, date plans, or quiet recovery time.",
    benefits: [
      "Shared stress relief and a memorable spa experience for two",
      "Relaxation therapy that supports comfort and emotional ease",
      "Premium massage care in a polished, coordinated setting",
      "A calming wellness experience that feels indulgent and special",
    ],
    whyChoose: [
      "A luxury spa setup designed specifically for shared relaxation",
      "Professional therapists who coordinate the experience smoothly for both guests",
      "Clean, high-comfort treatment standards with premium hospitality",
      "A beautiful choice for couples, close friends, and celebration plans",
    ],
    experience: [
      "Consultation: Review comfort preferences for both guests before the session.",
      "Therapy: Enjoy side-by-side massage therapy in a calm, premium spa setting.",
      "Relaxation: Finish together with a lighter body and a more peaceful mood.",
    ],
    image: "/assets/7-spa.jpg",
  },
  {
    title: "Oil Massage",
    tagline:
      "Warm oils, flowing strokes, and a rich spa rhythm create a deeply soothing experience.",
    description:
      "Oil Massage delivers a gentle yet luxurious massage and spa service that supports relaxation, comfort, and overall body softness.",
    about:
      "This modality is ideal when the goal is full-body relaxation rather than intense pressure. It combines nourishing oil work with a premium spa atmosphere to help the body settle, reduce stress, and create a more restful after-feel.",
    benefits: [
      "Stress relief with a warm, comfort-led massage style",
      "Relaxation therapy that softens the body and calms the mind",
      "A soothing massage experience that may support better sleep",
      "A polished spa service that feels gentle, rich, and restorative",
    ],
    whyChoose: [
      "A premium oil massage experience with elegant, flowing technique",
      "Professional therapists who focus on body comfort and relaxation pacing",
      "High hygiene and guest-care standards for a reassuring treatment",
      "Excellent for guests who want nurturing wellness support and soft recovery",
    ],
    experience: [
      "Consultation: Review comfort, oil preference, and desired massage intensity.",
      "Therapy: Enjoy warm, flowing massage techniques designed to ease stress and fatigue.",
      "Relaxation: Finish with a soothed body, a calmer mood, and a polished spa after-feel.",
    ],
    image: "/assets/4-spa.jpg",
  },
  {
    title: "Swedish Massage",
    tagline:
      "A timeless relaxation massage with graceful strokes and a beautifully calming finish.",
    description:
      "Swedish Massage is a premium spa favorite that supports stress relief, gentle muscular comfort, and an easy full-body sense of relaxation.",
    about:
      "Guests who want massage in Pune with balanced pressure and a classic spa feel often choose Swedish Massage. It offers a clean, approachable relaxation therapy format that helps the body unwind without the intensity of deeper corrective work.",
    benefits: [
      "Stress relief through smooth, flowing massage therapy",
      "Gentle support for body tension and day-to-day fatigue",
      "Relaxation that may help the mind settle and sleep improve",
      "A classic spa service for regular wellness and calm recovery",
    ],
    whyChoose: [
      "A luxury version of a trusted and widely loved massage style",
      "Professional therapists who deliver balanced, comfort-led pressure",
      "Hygienic service and a polished guest experience throughout the session",
      "Ideal for beginners, regular spa guests, and anyone seeking calm",
    ],
    experience: [
      "Consultation: Share your comfort level and any preferred focus areas.",
      "Therapy: Enjoy long, relaxing massage strokes designed to soothe the whole body.",
      "Relaxation: Leave refreshed, more comfortable, and mentally quieter.",
    ],
    image: "/assets/2-spa.jpg",
  },
];

const createFaqs = (title) => [
  {
    question: `What makes ${title} different from a regular massage?`,
    answer:
      "It combines a premium spa atmosphere with focused relaxation therapy, helping guests enjoy both physical comfort and a more polished wellness experience.",
  },
  {
    question: "Can this treatment help with stress relief?",
    answer:
      "Yes. Each modality is designed to calm the body, reduce tension, and support a more restful, relaxed state after the session.",
  },
  {
    question: "Will this spa service help with better sleep?",
    answer:
      "Many guests feel calmer and more settled afterward, which can make it easier to unwind and rest more comfortably.",
  },
  {
    question: "Is this modality suitable for first-time spa guests?",
    answer:
      "Yes. The treatment can be adapted to your comfort level, and our team guides the experience so it feels smooth and reassuring.",
  },
  {
    question: "How can I book this modality?",
    answer:
      "Call our team directly for availability, guidance on the best option for your needs, and quick booking support.",
  },
];

export const modalities = modalityEntries.map((modality, index) => ({
  id: `modality-${index + 1}`,
  slug: createSlug(modality.title),
  ctaLabel: "Call Now",
  metaDescription: `${modality.title} for massage in Pune, spa service, home massage, and relaxation therapy with premium booking support from 24 Night Spa.`,
  faqs: createFaqs(modality.title),
  ...modality,
}));

export const getModalityBySlug = (slug) =>
  modalities.find((modality) => modality.slug === slug);

export const getRelatedModalities = (currentSlug) =>
  modalities.filter((modality) => modality.slug !== currentSlug).slice(0, 3);
